<template>
  <Page back-to="/admin/professionals" title="Novo profissional">
    <v-container style="max-width: 1000px">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <v-form @submit.prevent="handleSubmitForm()">
          <v-card>
            <v-card-text>
              <v-row>
                <v-subheader> DADOS PESSOAIS </v-subheader>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.name"
                      name="name"
                      label="Nome completo"
                      outlined
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="5" md="4" lg="2">
                  <ValidationProvider
                    name="birth_date"
                    rules=""
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.birth_date"
                      name="birth_date"
                      label="Nascimento"
                      outlined
                      type="date"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="designation"
                    rules="required|max:45"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.designation"
                      label="Título"
                      outlined
                      counter="45"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="email"
                    rules="required|email|max:100"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.email"
                      label="Email"
                      outlined
                      type="email"
                      counter="100"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="5" md="4" lg="2">
                  <ValidationProvider
                    name="phone_number"
                    rules="required|max:20"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.phone_number"
                      label="Telefone"
                      outlined
                      counter="20"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="cnpj"
                    rules="required|max:25"
                    v-slot="{ errors }"
                  >
                    <v-text-field-cnpj
                      v-model="form.cnpj"
                      label="CNPJ"
                      v-bind:properties="{
                        outlined: true,
                        'error-messages': errors
                      }"
                    ></v-text-field-cnpj>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="cpf"
                    v-slot="{ errors }"
                    rules="required|max:45"
                  >
                    <v-text-field-cpf
                      v-model="form.cpf"
                      label="CPF"
                      v-bind:properties="{
                        outlined: true,
                        'error-messages': errors
                      }"
                    ></v-text-field-cpf>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="rg"
                    v-slot="{ errors }"
                    rules="required|max:45"
                  >
                    <v-text-field-simplemask
                      v-model="form.rg"
                      label="RG"
                      v-bind:properties="{
                        outlined: true,
                        'error-messages': errors
                      }"
                      v-bind:options="{
                        inputMask: '##.###.###-#',
                        outputMask: '#########',
                        empty: '',
                        applyAfter: false,
                        alphanumeric: true
                      }"
                    ></v-text-field-simplemask>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-subheader> ENDEREÇO </v-subheader>
              </v-row>
              <v-row dense>
                <v-col md="3">
                  <ValidationProvider
                    name="country"
                    rules="required|max:45"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      name="country"
                      v-model="form.country"
                      label="País"
                      outlined
                      counter="45"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col>
                  <ValidationProvider
                    name="postal_code"
                    rules="max:45"
                    v-slot="{ errors }"
                  >
                    <v-text-field-cep
                      v-model="form.postal_code"
                      label="CEP"
                      v-bind:properties="{
                        outlined: true,
                        'error-messages': errors
                      }"
                    ></v-text-field-cep>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col md="2">
                  <ValidationProvider
                    name="state_address"
                    rules="required|max:75"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      counter="75"
                      label="Estado"
                      outlined
                      v-model="form.state_address"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col>
                  <ValidationProvider
                    name="city_address"
                    rules="required|max:75"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      counter="75"
                      label="Cidade"
                      outlined
                      v-model="form.city_address"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="9" md="10">
                  <ValidationProvider
                    name="address"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.address"
                      label="Logradouro"
                      outlined
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col sm="3" md="2">
                  <ValidationProvider
                    name="address_number"
                    rules="max:10"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.address_number"
                      label="Número (opcional)"
                      outlined
                      counter="10"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="neighborhood"
                    rules="required|max:100"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.neighborhood"
                      label="Bairro"
                      outlined
                      counter="100"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="address_complement"
                    rules="max:45"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.address_complement"
                      label="Complemento (opcional)"
                      outlined
                      counter="45"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-subheader> PAGAMENTO </v-subheader>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="income (opcional)"
                    rules="min_value:0"
                    v-slot="{ errors }"
                    lazy
                  >
                    <MoneyInput
                      name="income"
                      v-model="form.income"
                      :error-messages="errors"
                      label="Salário"
                      outlined
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="pix"
                    rules="max:45"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.pix"
                      label="PIX"
                      outlined
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-subheader> ACESSOS </v-subheader>
              </v-row>
              <v-row dense>
                <v-col>
                  <UserPicker
                    v-model="form.user_id"
                    outlined
                    label="Credenciais"
                    clearable
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-subheader> ADMINISTRATIVAS </v-subheader>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="5" md="4" lg="2">
                  <ValidationProvider
                    name="started_at"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="form.started_at"
                      label="Data de inicio"
                      outlined
                      type="date"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <ValidationProvider
                    name="observation"
                    rules="max:255"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="form.observation"
                      label="Observações"
                      outlined
                      counter="255"
                      :error-messages="errors"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn type="submit" color="primary" :loading="submitting">
                Salvar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn to="/admin/professionals" exact outlined>Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </ValidationObserver>
    </v-container>
  </Page>
</template>

<script>
import { store } from "@/services/professionals";
import MoneyInput from "@/components/MoneyInput";
import Page from "@/components/layout/Page";
import UserPicker from "@/components/users/UserPicker";

export default {
  name: "new_professional",
  components: { MoneyInput, Page, UserPicker },
  data: () => ({
    form: {},
    submitting: false,
  }),
  methods: {
    async handleSubmitForm() {
      const validation = await this.$refs.form.validate();
      if (!validation) return;

      this.submitting = true;
      try {
        const response = await store(this.form);
        this.$store.commit("info", "Novo profissional criado!");
        this.$router.replace("/admin/professionals/" + response.id);
      } catch (error) {
        if (error.response.status == 422) {
          this.$refs.form.setErrors(error.response.data.errors);
          this.$store.commit(
            "error",
            "Corrija os campos com erro e tente novamente."
          );

          return;
        }

        this.$store.commit("error", error);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>